module.exports = __webpack_public_path__ + "static/media/South-mobile.fc4b206f.jpg";